module.exports = __webpack_public_path__ + "static/media/natal.958a196a.svg";